import type React from "react"

import { cn, Field, FieldError, FieldLabel, Input } from "@atlant/ui"

interface FormInputProps {
  value: string | undefined
  onChange: (value: string) => void
  onBlur?: () => void
  name?: string
  label?: string
  placeholder?: string
  type?: "text" | "email" | "password" | "number" | "tel"
  disabled?: boolean
  maxLength?: number
  className?: string
  inputClassName?: string
  error?: string
  required?: boolean
}

export const FormInput = ({
  value,
  onChange,
  onBlur,
  name,
  label,
  placeholder,
  type = "text",
  disabled,
  maxLength,
  className,
  inputClassName,
  error,
  required,
}: FormInputProps) => {
  const id = name ?? label?.toLowerCase().replace(/\s+/g, "-")

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value)
  }

  return (
    <Field className={className} data-invalid={error ? true : undefined}>
      {label && (
        <FieldLabel
          htmlFor={id}
          className="text-muted-foreground gap-1 text-sm font-medium"
        >
          {label}
          {required && <span className="text-xs text-red-500">*</span>}
        </FieldLabel>
      )}
      <Input
        id={id}
        name={name}
        type={type}
        value={value ?? ""}
        onChange={handleChange}
        onBlur={onBlur}
        placeholder={placeholder}
        disabled={disabled}
        maxLength={maxLength}
        aria-invalid={error ? true : undefined}
        className={cn(
          "shadow-custom! placeholder:text-placeholder h-10 bg-white placeholder:text-sm" +
            " dark:shadow-none!",
          inputClassName,
        )}
      />
      {error && <FieldError>{error}</FieldError>}
    </Field>
  )
}
